import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { AdditionalStyleSheet, MandatoryAdditionalStyle } from '../components.utils';
import { BlockWidths } from '../components/pageLayouts/BlockTypes.utils';
import { useTheme } from '../../theming/useTheme';
import { TranslatedFontSize } from '../../theming/fontSizeTranslator';
import { RawHtmlContent } from './RawHtmlContent';

interface RawHtmlContentWithThemeStyleComponentProps extends MandatoryAdditionalStyle{
    html: string;
    dataId?: string;
    defaultBlocksWidths: BlockWidths;
}

export const createAdditionalStyle = (fontFamilyNormal: string, additionalStyle: AdditionalStyleSheet) => StyleSheet.create({
  style: {
    ...additionalStyle.style,
    fontFamily: fontFamilyNormal,
  },
}) as AdditionalStyleSheet;

export const RawHtmlContentWithThemeStyle: React.FunctionComponent<RawHtmlContentWithThemeStyleComponentProps> = props => {
  const { html, additionalStyle, dataId, defaultBlocksWidths } = props;
  const { fontSizesStyles }: { fontSizesStyles: TranslatedFontSize } = useTheme();

  return (
    <RawHtmlContent
      key={dataId}
      html={html}
      dataId={dataId}
      defaultBlocksWidths={defaultBlocksWidths}
      additionalStyle={createAdditionalStyle(fontSizesStyles.normal.style.fontFamily, additionalStyle)}
    />
  );
};
